/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StakingService {
    /**
     * @param apy
     * @param offset
     * @param limit
     * @param account
     * @param amountFrom
     * @param amountTo
     * @param stakedAtFrom
     * @param stakedAtTo
     * @returns any
     * @throws ApiError
     */
    public static listStakings(
        apy: number,
        offset?: number,
        limit: number = 10,
        account?: string,
        amountFrom?: number,
        amountTo?: number,
        stakedAtFrom?: number,
        stakedAtTo?: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/staking',
            query: {
                'offset': offset,
                'limit': limit,
                'account': account,
                'apy': apy,
                'amountFrom': amountFrom,
                'amountTo': amountTo,
                'stakedAtFrom': stakedAtFrom,
                'stakedAtTo': stakedAtTo,
            },
        });
    }
}
